// Auto-generated skeleton for Record

import { RecordStatus } from "./RecordStatus";
import { Team } from "./Team";

export const Record: Api.Record = {
  id: 0,
  hp_id: null,
  search: null,
  info_1: null,
  info_2: null,
  created_hp: '',
  closed: null,
  status_id: 0,
  status: RecordStatus,
  team_id: 0,
  team: Team,
  units: [],
  buildings: [],
  role_permissions: [],
  craftsman_tasks: [],
  tickets: [],
  cis: [],
  tasks: [],
  documents: [],
  created: null,
  updated: null,
};

